<template>
  <div class="medication-list">
    <template v-if="medications.length">
      <medication-list-item
        v-for="medication in medications"
        :key="`${type}-${medication.id}`"
        :medication="medication"
        :type="type"
        :selected="isSelected(medication.id)"
        @select="handleMedicationSelect"
        @edit-medication="handleEditMedication"
        @show-previous-dispenses="$emit('show-previous-dispenses', $event)" />
    </template>
    <template v-else>
      <slot name="no-content">
        <div class="no-content">
          No se han ingresados medicamentos
        </div>
      </slot>
    </template>
    <div class="medication-list__footer">
      <button
        v-if="selectedMedications.length"
        type="button"
        :disabled="!selectedMedications.length"
        class="btn btn-warning mr-4"
        @click="handleClickDeleteMedication">
        <i class="fas fa-trash-alt" /> Eliminar Seleccionados
      </button>
      <button type="button" class="btn btn-add" @click="handleCLickAddMedication" :disabled="isBlocked">
        Agregar Medicamento<i class="fas fa-plus-circle ml-auto" />
      </button>
    </div>
  </div>
</template>

<script>
import MedicationListItem from '@/components/medication/MedicationListItem';
export default {
  name: 'MedicationList',
  components: { MedicationListItem },
  props: {
    medications: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'medication-request'
    }
  },
  data() {
    return {
      selectedMedications: []
    };
  },
  computed: {
    isBlocked(){
      let bloquear = false;
      this.medications.forEach(med => {
        if(med.data.retainPrescription){
          bloquear = true;
        }
      });

      return bloquear;
    }
  },
  methods: {
    handleMedicationSelect(medicationId) {
      if (this.isSelected(medicationId)) {
        this.selectedMedications.splice(this.selectedMedications.findIndex(m => m.id === medicationId), 1);
      } else {
        this.selectedMedications.push(medicationId);
      }
    },
    isSelected(medicationId) {
      return this.selectedMedications.includes(medicationId);
    },
    handleClickDeleteMedication() {
      this.$emit('delete-medications', this.selectedMedications, this.type);
      this.selectedMedications.splice(0);
    },
    handleCLickAddMedication() {
      this.$emit('add-medication');
    },
    handleEditMedication(medication) {
      this.$emit('edit-medication', medication);
    }
  }
};
</script>

<style lang="scss">
.medication-list {
  &__header {
    display: flex;
    justify-content: space-between;
    padding-bottom: $--spacing-4;
  }
  &__footer {
    display: flex;
  }
  &-item {
    margin-bottom: $--spacing-4;
  }
}
</style>
